<div class="branches-tpl">
	<div class="header">
		<div class="header-title">
			<span i18n="@@branches.tpl.enter_template_name">Enter Template Name</span>
			<h1 i18n="@@branches.tpl.default_settings_template">Default settings template</h1>
			<span i18n="@@branches.tpl.create_template_description">Create a template that will apply to all stores.
				You can override individual fields if needed lately.</span>
		</div>
		<div class="controls">
			<button type="button" class="skip-tpl" (click)="skipTemplate()" i18n="@@branches.tpl.skip_template">
				Skip template
			</button> 
			<button type="button" class="save-tpl" form="ngForm" (click)="informationForm.ngSubmit.emit()">
				<ng-container i18n="@@branches.tpl.save_and_continue">Save & continue</ng-container>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round" />
				</svg>
			</button>
		</div>
	</div>
	<form [formGroup]="storeInformationForm" (ngSubmit)="onSubmit()" id="ngForm" #informationForm="ngForm">
		<div class="tpl-form">
			<!-- <div class="tpl-cover">
				<div class="upload-area w-100">
					<div class="upload-area__img">
						<img src="/images/store-branches/upload.svg" alt="img-cover" />
						<span i18n="@@branches.tpl.upload_cover_photo">Upload cover photo</span>
					</div>
					<fieldset class="logo-uploder w-100">
						<file-pond #logoFile [options]="pondOptions" [files]="coverImageUrl" (oninit)="pondHandleInit()"
							(onaddfile)="pondHandleAddFile($event)" (onprocessfileabort)="pondHandleRemoveFile($event)">
						</file-pond>
					</fieldset>
					<div class="upload-area__desc">
						<span class="text" i18n="@@branches.tpl.drag_drop_or_choose_file">Drag & Drop or Choose File to
							upload</span>
						<span i18n="@@branches.tpl.upload_best_results">Upload 1100 x 200 px PNG image for best
							results.</span>
					</div>
				</div>
			</div> -->
			<div class="tpl-cover" [style.background-image]="coverPhoto ? 'url(' + coverPhoto + ')' : 'none'"
				[style.border]="coverPhoto ? 'none' : '2px dashed #ccc'" (click)="triggerFileInput()"
				(dragover)="onDragOver($event)" (drop)="onDrop($event)">
				<div class="upload-area" *ngIf="!coverPhoto">
					<div class="upload-area__img">
						<img src="/images/store-branches/upload.svg" alt="img-cover" />
						<span i18n="@@branches.tpl.upload_cover_photo">Upload cover photo</span>
					</div>
					<div class="upload-area__desc">
						<span class="text" i18n="@@branches.tpl.drag_drop_or_choose_file">Drag & Drop or <span>Choose File</span> to
							upload</span>
						<span i18n="@@branches.tpl.upload_best_results">Upload 1100 x 200 px PNG image for best results.</span>
					</div>
				</div>
				<div class="upload__actions" *ngIf="coverPhoto">
					<label class="upload-illustration__change" (click)="triggerFileInput()"
						i18n="@@branches.tpl.change_cover_photo">
						Change cover photo
					</label>
					<!-- <button type="button" class="upload-illustration__reposition" i18n="@@branches.tpl.reposition">
						Reposition
					</button> -->
				</div>
				<input #fileInput type="file" hidden (change)="onChangePhoto($event)" />
			</div>

			<div class="form-row align-items-start">
				<fieldset class="form-group" [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
					<label class="mbranch-label" for="storeName" i18n="@@business.business_name">Business Name</label>
					<input id="storeName" class="form-control" type="text" name="store-name" formControlName="name"
						(keyup)="convertToSlug($event.target.value)" (blur)="convertToSlug($event.target.value)" />
					<span class="field-error" i18n="@@error.required.store_name"
						*ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Store name is required</span>
					<span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
				</fieldset>
				<div class="form-group">
					<label class="mbranch-label" for="link" i18n="@@branches.tpl.store_link">Store Link (Useful for sending URLs to customers)</label>
					<input id="link" type="text" class="form-control" placeholder="www.app.teem-app.com/branch-name"
						name="catalogue_link" #slug formControlName="slug" (keyup)="convertToSlug(slug.value)"
						(blur)="convertToSlug(slug.value)" />
					<span class="field-error" i18n="@@error.required"
						*ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.required">Required</span>
					<span class="field-error" i18n="@@error.slug_taken"
						*ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.slugTaken">Slug is already taken</span>
					<span class="field-error" *ngIf="f.slug.errors?.serverError">{{ f.slug.errors?.serverError }}</span>
					<span class="catalogue-details__businessUrl">{{ storeUrl }}</span>
				</div>
			</div>

			<div class="form-row">
				<div class="form-group">
					<label class="mbranch-label" i18n="@@branches.tpl.business_type">Business Type</label>
					<div class="radio-group">
						<!-- <label class="radio-wrapper" *ngFor="let type of businessTypes">
							<input type="radio" name="business-type" name="add-storeItem"
								(click)="onBusinessTypeChange.emit(type.toLowerCase())"
								[checked]="myStoreType.toLowerCase() == type.toLowerCase() ? true : false" />
							<span class="custom-radio"></span>
							{{ type }}
						</label> -->
						<label class="radio-wrapper">
							<input type="radio" name="business-type" name="add-storeItem"
								(click)="onBusinessTypeChange.emit('product')"
								[checked]="myStoreType.toLowerCase() == 'product' ? true : false" />
							<span class="custom-radio"></span>
							<ng-container i18n="@@branches.tpl.product">Product</ng-container>
						</label>
						<label class="radio-wrapper">
							<input type="radio" name="business-type" name="add-storeItem"
								(click)="onBusinessTypeChange.emit('service')"
								[checked]="myStoreType.toLowerCase() == 'service' ? true : false" />
							<span class="custom-radio"></span>
							<ng-container i18n="@@branches.tpl.service">Service</ng-container>
						</label>
					</div>
				</div>
				<div class="form-group">
					<!-- <div class="categories-block"> -->
						<!-- <div class="category-wrapper">
							<div class="badges-track">
								<span class="mbranch-cat__badge" *ngFor="let cat of categories; let i = index">
									{{ cat }}
									<button type="button" class="remove-btn" (click)="removeCategory(i)">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
											<path d="M12 4L4 12M4 4L12 12" stroke="#EB1461" stroke-width="1.5"
												stroke-linecap="round" stroke-linejoin="round" />
										</svg>
									</button>
								</span>
							</div>
							<div class="categories-input">
								<input  type="text" [(ngModel)]="categoryInput" placeholder="Add categories" />
								<button type="button" (click)="addCategory()" class="add-category-btn">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
										fill="none">
										<path d="M12 5V19M5 12H19" stroke="#393939" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</button>
							</div>
						</div> -->
						<div class="status_wrap w-100 w-none-100 store-information--box">
							<fieldset class="add-categories pb-4" [ngClass]="{ 'has-error': (isSubmitted || f.storefront_categories.dirty) && f.storefront_categories?.errors }">
								<label class="mbranch-label" i18n="@@branches.tpl.add_categories">Add Categories</label>
								<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: storeFrontCategoriesApi}, idColumn: 'name',textColumn: 'name', maxLength: 3}" [selected]="selectedStorefrontCategories ? selectedStorefrontCategories : null" i18n-data-placeholder="@@store.add_storefront_categories" data-placeholder="Add Storefront Categories" formControlName="storefront_categories" multiple="multiple"></select>
								<span class="field-error" *ngIf="(isSubmitted || f.storefront_categories.dirty) && f.storefront_categories.errors?.required">Add at least one category</span>
								<span class="field-error" *ngIf="f.storefront_categories.errors?.serverError">{{ f.storefront_categories.errors?.serverError }}</span>
							</fieldset>
						</div>
						<!-- <div class="status_wrap store-information--box">
							<fieldset class="add-categories pb-4">
								<label>
									<ng-container i18n="@@store.add_categories">Add product Categories</ng-container>
								</label>
								<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: productCategoriesApi}, idColumn: 'name',textColumn: 'name', tags: true}" (onUnselect)="onUnselectProductCategory($event)" [selected]="selectedProductCategories ? selectedProductCategories : null" i18n-data-placeholder="@@store.add_product_categories" data-placeholder="Add Product Categories" formControlName="product_categories" multiple="multiple"></select>

								<span class="field-error" *ngIf="(isSubmitted || f.product_categories.dirty) && f.product_categories.errors?.required">Add at least one category</span>
								<span class="field-error" *ngIf="f.product_categories.errors?.serverError">{{ f.product_categories.errors?.serverError }}</span>
							</fieldset>
						</div> -->
					<!-- </div> -->
				</div>
			</div>

			<div class="form-group">
				<label class="mbranch-label" for="desc" i18n="@@branches.tpl.business_description">Business Description</label>
				<textarea id="desc" class="form-control" placeholder="Enter business description" rows="6" formControlName="description"></textarea>
			</div>

			<div class="form-row">
				<fieldset class="form-group" [ngClass]="{ 'has-error':( isSubmitted || f.phone.dirty) && f.phone?.errors }">
					<label class="mbranch-label" i18n="@@branches.tpl.contact_number">Contact Number</label>
					<input id="num" type="text" class="form-control" placeholder="Enter contact number" formControlName="phone"/>
					<span i18n="@@error.required.contact" class="field-error"
						*ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.required">Phone number is required
					</span>
					<span class="field-error" i18n="@@error.phone_number_only"
						*ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.pattern">Please enter number only
					</span>
					<span class="field-error" i18n="@@error.required.contact_number_between"
						*ngIf="(isSubmitted || f.phone.dirty) && (f.phone.errors?.minlength || f.phone.errors?.maxlength)">The
						phone number must be less than 5 and 30 digits</span>
					<span class="field-error" *ngIf="f.phone.errors?.serverError">{{ f.phone.errors?.serverError
						}}</span>
				</fieldset>
				<div class="form-group">
					<label class="mbranch-label" for="whatsapp" i18n="@@branches.tpl.whatsapp_number">Whatsapp Business
						Number </label>
					<fieldset class="input-with-prefix"
						[ngClass]="{ 'has-error':( isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone?.errors }">
						<span class="prefix">https://wa.me/</span>
						<input id="whatsapp" type="text" class="form-control" placeholder="+966 123 456 789"
							formControlName="whatsapp_phone" />
						<span i18n="@@error.required.contact" class="field-error"
							*ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.required">Whatsapp
							number is required </span>
						<span class="field-error" i18n="@@error.whatsapp_phone_number_only"
							*ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.pattern">Please
							enter number only </span>
						<span class="field-error" i18n="@@error.required.contact_number_between"
							*ngIf="(isSubmitted || f.whatsapp_phone.dirty) && (f.whatsapp_phone.errors?.minlength || f.whatsapp_phone.errors?.maxlength)">The
							Whatsapp number must be less than 5 and 30 digits</span>
						<span class="field-error" *ngIf="f.whatsapp_phone.errors?.serverError">{{
							f.whatsapp_phone.errors?.serverError }}</span>
					</fieldset>
				</div>
			</div>

			<div class="form-row top">
				<div class="form-col">
					<div class="d-flex align-items-center gap-2 mb-2">
						<div class="custom-checkbox">
							<input class="select-item orders_inputAll" id="allow-instant-order" type="checkbox"
								formControlName="allow_instant_order">
							<svg *ngIf="!storeInformationForm.get('allow_instant_order')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
								viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg *ngIf="storeInformationForm.get('allow_instant_order')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
									stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<label class="mbranch-label" for="allow-instant-order" i18n="@@store.tpl.allow_instant_order">Allow instant order</label>
					</div>

					<div class="d-flex align-items-center gap-2 mb-2">
						<div class="custom-checkbox">
							<input class="select-item orders_inputAll" id="allow-scheduled-order" type="checkbox"
								formControlName="allow_scheduled_order">
							<svg *ngIf="!storeInformationForm.get('allow_scheduled_order')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
								viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg *ngIf="storeInformationForm.get('allow_scheduled_order')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
									stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<label class="mbranch-label" for="allow-scheduled-order" i18n="@@store.tpl.allow_scheduled_order">Allow scheduled order</label>
					</div>

					<div class="d-flex align-items-center gap-2 mb-2">
						<div class="custom-checkbox">
							<input class="select-item orders_inputAll" id="checkbox-001" type="checkbox"
								formControlName="upload_reference_files">
							<svg  *ngIf="!storeInformationForm.get('upload_reference_files')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
								viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg  *ngIf="storeInformationForm.get('upload_reference_files')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
									stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<label class="mbranch-label" for="checkbox-001" i18n="@@allow_customers_to_upload_reference_files">
							Allow customers to upload reference files
						</label>
					</div>

					<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
						<div class="d-flex gap-2 align-items-center">
							<div class="custom-checkbox show_mandatory">
								<input tm-toggle="additioanl-information" class="select-item orders_inputAll"
									id="checkbox-002" type="checkbox" formControlName="allow_additional_info">
								<svg *ngIf="!storeInformationForm.get('allow_additional_info')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
									viewBox="0 0 24 24" fill="none">
									<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
								</svg>
								<svg *ngIf="storeInformationForm.get('allow_additional_info')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
										stroke-width="2" />
									<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
										stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</div>
							<label class="mbranch-label" for="checkbox-002" i18n="@@allow_customers_to_add_additional_info">
								Allow customer to add additional info
							</label>
						</div>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22"
								fill="none">
								<path
									d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z"
									stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<div class="help_tooltip_text" data-role="right">
								<ng-container i18n="@@store.allow_customers_to_add_additional_info_tooltip">
									Enable this field for your customers to add any comments during checkout.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"
									fill="none">
									<path
										d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z"
										fill="#EDEDED" />
								</svg>
							</div>
						</div>
					</div>
					<div class="user_info_container gap-3" [class.d-none]="!f.allow_additional_info.value">
						<ng-container formArrayName="additional_info">
							<ng-container *ngFor="let item of additionalInfo.controls; let i=index" [formGroupName]="i">
								<div
									class="align-items-center gap-4 flex-none-column align-items-none-start mandatory_field">
									<div class="d-md-flex gap-4 align-items-center position-relative w-none-98">
										<div class="input-group w-100 w-md-50">
											<fieldset class="no-label mb-3"
												[ngClass]="{ 'has-error': isSubmitted && getInformationFormGroup(i).get('information')?.invalid }">
												<textarea name="description"
													i18n-placeholder="@@setting.additional_info"
													placeholder="Additional information" formControlName="information"
													maxlength="78"></textarea>
												<span class="field-error" i18n="@@error.required"
													*ngIf="isSubmitted && getInformationFormGroup(i).get('information')?.errors?.required">*
													Required</span>
											</fieldset>
										</div>
										<div class="d-flex justify-content-between pt-2">
											<div class="d-flex align-items-center gap-3">
												<div class="custom-checkbox">
													<input class="select-item orders_inputAll" id="index-{{i}}"
														type="checkbox" formControlName="make_mandatory"
														(click)="makeMandatory(i, $event)">
													<svg *ngIf="!storeInformationForm.get('make_mandatory')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24"
														height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0"
															stroke-width="2" />
													</svg>
													<svg *ngIf="storeInformationForm.get('make_mandatory')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20"
														fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6"
															stroke="#1C6AB6" stroke-width="2" />
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white"
															stroke-width="2" stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<label class="mbranch-label" for="index-{{i}}" i18n="@@make_mandatory">Make mandatory</label>
											</div>
										</div>
										<svg class="close_icon" xmlns="http://www.w3.org/2000/svg" width="24"
											height="24" viewBox="0 0 24 24" fill="none" *ngIf="i != 0"
											(click)="deleteAdditionalInfo(i)">
											<path
												d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
												stroke="#EB1461" stroke-width="2" stroke-linecap="round"
												stroke-linejoin="round" />
										</svg>
									</div>
									<div class="w-50 d-flex align-items-center gap-2 pl-4 w-none-100 pl-none-0">
									</div>
								</div>
							</ng-container>
						</ng-container>

						<button type="button" id="add_field" class="btn w-auto add_field mt-4" (click)="addAdditionalInfo()">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
								fill="none">
								<path d="M10.0001 4.16666V15.8333M4.16675 9.99999H15.8334" stroke="white"
									stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<ng-container i18n="@@add_another">Add field</ng-container>
						</button>
					</div>

					<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
						<div class="d-flex gap-2 align-items-center">
							<div class="custom-checkbox show_comments">
								<input tm-toggle="shop-comments" class="select-item orders_inputAll" id="checkbox-005"
									type="checkbox" formControlName="allow_shop_comment"
									(click)="allowShopComments($event)">
								<svg *ngIf="!storeInformationForm.get('allow_shop_comment')?.value" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
									viewBox="0 0 24 24" fill="none">
									<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
								</svg>
								<svg *ngIf="storeInformationForm.get('allow_shop_comment')?.value" class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
										stroke-width="2" />
									<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
										stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</div>
							<label class="mbranch-label" for="checkbox-005" i18n="@@add_shop_comments">Add Shop comments </label>
						</div>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22"
								fill="none">
								<path
									d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z"
									stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<div class="help_tooltip_text" data-role="right">
								<ng-container i18n="@@store.add_shop_comments_tooltip">
									Enable this field for your customers to add any comments while ordering.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"
									fill="none">
									<path
										d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z"
										fill="#EDEDED" />
								</svg>
							</div>
						</div>
					</div>
					<div id="shop-comments"
						class="align-items-center gap-4 mb-2 flex-none-column align-items-none-start comments_field"
						[class.d-none]="!f.allow_shop_comment.value">
						<div class="w-50 position-relative w-none-98">
							<div class="input-group">
								<fieldset class=""
									[ngClass]="{ 'has-error':( isSubmitted || f.shop_comments.dirty) && f.shop_comments?.errors }">
									<label class="mbranch-label" i18n="@@shop_comments">Shop Comment</label>
									<textarea placeholder="e.g Please note any orders placed past 5pm will be rejected"
										formControlName="shop_comments"></textarea>
									<span
										*ngIf="(isSubmitted || f.shop_comments.dirty) && f.shop_comments.errors?.required"
										i18n="@@error.required" class="field-error">Shop Comment is required</span>
								</fieldset>
							</div>
						</div>
					</div>
				</div>

				<div class="form-innerbox">
					<h2 i18n="@@branches.tpl.store_location">Store location</h2>
					<div
						class="user_info_container gap-4 d-flex justify-content-between align-items-center flex-row flex-none-column align-items-none-start">
						<div class="w-50 service_hide  w-none-100">
							<fieldset
								[ngClass]="{ 'has-error': (isSubmitted || f.address.dirty) && f.address?.errors }">
								<label class="mbranch-label"> <ng-container i18n="@@google_pin_drop_location">Google pin drop location
									</ng-container> <a class="city-link" href="javascript:void(0)"
										(click)="openGoogleMap()" i18n="@@open_map"> open map</a></label>
								<input type="text" name="drop-location" formControlName="address" readonly>
								<span class="field-error" i18n="@@error.required.address"
									*ngIf="(isSubmitted || f.address.dirty) && f.address.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.address.errors?.serverError">{{
									f.address.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="w-50 service_hide"></div>
					</div>

					<div
						class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.building_name.dirty) && f.building_name?.errors }">
								<label class="mbranch-label" i18n="@@business.building_name">Building Name</label>
								<input type="text" name="building_name" formControlName="building_name"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.building_name"
									*ngIf="(isSubmitted || f.building_name.dirty) && f.building_name.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.building_name.errors?.serverError">{{
									f.building_name.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.street.dirty) && f.street?.errors }">
								<label class="mbranch-label" i18n="@@business.street">Street</label>
								<input type="text" name="street" formControlName="street"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.street"
									*ngIf="(isSubmitted || f.street.dirty) && f.street.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.street.errors?.serverError">{{
									f.street.errors?.serverError }}</span>
							</fieldset>
						</div>
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.area.dirty) && f.area?.errors }">
								<label class="mbranch-label" i18n="@@business.area">Area</label>
								<input type="text" name="area" formControlName="area"
									(keypress)="validateInput($event)" />
								<span class="field-error" i18n="@@error.required.area"
									*ngIf="(isSubmitted || f.area.dirty) && f.area.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.area.errors?.serverError">{{
									f.area.errors?.serverError }}</span>
							</fieldset>
						</div>
					</div>

					<div
						class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
						<div class="d-flex flex-column w-50 gap-3 w-none-100">
							<fieldset class=""
								[ngClass]="{ 'has-error': (isSubmitted || f.country_id.dirty) && f.country_id?.errors }">
								<label class="mbranch-label" i18n="@@store.country">Country</label>
								<select app-select2 [options]="{
                  ajax: {url: countryListApi},
                  idColumn: 'id',
                  textColumn: 'name'
                }" (itemSelected)="onChangeCountry($event)"
									[selected]="selectedCountry ? {id: selectedCountry?.id, text: selectedCountry?.name} : null"
									i18n-placeholder="@@business.country_placeholder"
									placeholder="Please type country name" name="country_id"
									formControlName="country_id">
									<option></option>
								</select>
								<span class="field-error" i18n="@@error.required"
									*ngIf="(isSubmitted || f.country_id.dirty) && f.country_id.errors?.required">Required</span>
								<span class="field-error" *ngIf="f.country_id.errors?.serverError">{{
									f.country_id.errors?.serverError }}</span>
							</fieldset>
						</div>

						<ng-container *ngIf="outsideSA; else insideSA">
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.city.dirty) && f.city?.errors }">
									<label class="mbranch-label" i18n="@@store.city">City</label>
									<input type="text" name="city" formControlName="city">
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.city.dirty) && f.city.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.city.errors?.serverError">{{
										f.city.errors?.serverError }}</span>
								</fieldset>
							</div>
						</ng-container>
						<ng-template #insideSA>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.region_id.dirty) && f.region_id?.errors }">
									<label class="mbranch-label" i18n="@@store.region">Region</label>
									<select app-select2 [options]="{
                    ajax: {url: regionListApi},
                    idColumn: 'id',
                    textColumn: 'name'
                  }" (itemSelected)="onChangeRegion($event)"
										[selected]="selectedRegion ? {id: selectedRegion.id, text: selectedRegion.name}  : {}"
										i18n-placeholder="@@store.please_select" data-placeholder="Select Region"
										formControlName="region_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.region_id.dirty) && f.region_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.region_id.errors?.serverError">{{
										f.region_id.errors?.serverError }}</span>
								</fieldset>
							</div>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.city_id.dirty) && f.city_id?.errors }">
									<label class="mbranch-label" i18n="@@store.city">City</label>
									<select app-select2 [options]="{
                    data: cities ? cities : [],
                    idColumn: 'id',
                    textColumn: 'name'
                  }" [params]="{cityId:f.region_id.value}" (itemSelected)="onChangeCity($event)"
										[selected]="selectedCity ? {id: selectedCity.id, text: selectedCity.name}  : {}"
										i18n-placeholder="@@store.please_select" placeholder="Select City"
										data-placeholder="Select City" formControlName="city_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.city_id.dirty) && f.city_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.city_id.errors?.serverError">{{
										f.city_id.errors?.serverError }}</span>
								</fieldset>
							</div>
							<div class="d-flex flex-column w-50 gap-3 w-none-100">
								<fieldset class=""
									[ngClass]="{ 'has-error': (isSubmitted || f.district_id.dirty) && f.district_id?.errors }">
									<label class="mbranch-label" i18n="@@store.district">District</label>
									<select app-select2 [options]="{
                    data: districts ? districts : [],
                    idColumn: 'id',
                    textColumn: 'name'
                  }" [selected]="selectedDistrict ? {id: selectedDistrict.id, text: selectedDistrict.name}  : {}"
										i18n-placeholder="@@store.please_select" placeholder="Select District"
										data-placeholder="Select District" formControlName="district_id">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required"
										*ngIf="(isSubmitted || f.district_id.dirty) && f.district_id.errors?.required">Required</span>
									<span class="field-error" *ngIf="f.district_id.errors?.serverError">{{
										f.district_id.errors?.serverError }}</span>
								</fieldset>
							</div>
						</ng-template>
					</div>
				</div>
			</div>

			<div class="form-innerbox lg" formGroupName="week_days">
				<h2 i18n="@@branches.tpl.working_hours">Working hours</h2>
				<div class="innerbox-row">
					<div class="form-group row fit">
						<div class="custom-checkbox">
							<input class="select-item" type="checkbox" id="everyday" [checked]="everyday.selected"
								(change)="onCheckboxChange($event, everyday.uuid)" formControlName="same_everyday"/>
							<svg *ngIf="!everyday.selected" class="unchecked" xmlns="http://www.w3.org/2000/svg"
								width="24" height="24" viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg *ngIf="everyday.selected" class="checked" width="20" height="20" viewBox="0 0 20 20"
								fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
									stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<label class="mbranch-label" for="everyday" i18n="@@branches.tpl.same_everyday">Same
							everyday</label>
					</div>
					<div class="form-group row fit">
						<div class="custom-checkbox">
							<input class="select-item" type="checkbox" id="is24HoursOpen"
								[checked]="is24HoursOpen.selected"
								(change)="onCheckboxChange($event, is24HoursOpen.uuid)" formControlName="is_24hour"/>
							<svg *ngIf="!is24HoursOpen.selected" class="unchecked" xmlns="http://www.w3.org/2000/svg"
								width="24" height="24" viewBox="0 0 24 24" fill="none">
								<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2" />
							</svg>
							<svg *ngIf="is24HoursOpen.selected" class="checked" width="20" height="20"
								viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6"
									stroke-width="2" />
								<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<label class="mbranch-label" for="is24HoursOpen" i18n="@@branches.tpl.open_24_hours">24-hours
							open</label>
					</div>
				</div>
				<div class="mbranch-schedule__list">
					<div class="schedule-item" *ngFor="let day of schedule; let i = index">
						<ng-container [formGroupName]="(day.day).toLowerCase()">
							<div class="schedule-item__toggle">
								<label class="switch">
									<input type="checkbox" formControlName="available" />
									<span class="slider"></span>
								</label>
								<ng-container [ngSwitch]="day.day">
									<span *ngSwitchCase="'Monday'" i18n="@@monday" class="days">Monday</span>
									<span *ngSwitchCase="'Tuesday'" i18n="@@tuesday" class="days">Tuesday</span>
									<span *ngSwitchCase="'Wednesday'" i18n="@@wednesday" class="days">Wednesday</span>
									<span *ngSwitchCase="'Thursday'" i18n="@@thursday" class="days">Thursday</span>
									<span *ngSwitchCase="'Friday'" i18n="@@friday" class="days">Friday</span>
									<span *ngSwitchCase="'Saturday'" i18n="@@saturday" class="days">Saturday</span>
									<span *ngSwitchCase="'Sunday'" i18n="@@sunday" class="days">Sunday</span>
								</ng-container>
								<!-- <span class="days">{{ day.day }}</span> -->
								<span class="summary" *ngIf="day.active && !day.expanded">
									<span *ngFor="let slotTime of day.slot; let j = index"><span *ngIf="j > 0">, </span>{{ slotTime.start || '--:--' }} - {{ slotTime.end || '--:--' }}</span>
								</span>
								<button type="button" class="dropdown-toggle" (click)="toggleDropdown(i)">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
										viewBox="0 0 25 24">
										<path d="M6.66675 9L12.6667 15L18.6667 9" stroke="#0A0A0A" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</button>
							</div>
							<div class="schedule-time w-100 d-flex" *ngIf="day.active && day.expanded">
								<div formArrayName="slots" class="w-100">
									<div class="gap-2 align-items-center d-flex pb-3" *ngFor="let slot of getSlots((day.day).toLowerCase()).controls; let i = index" [formGroupName]="i">
										<fieldset class="mb-0" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
											<input type="time" formControlName="start_time" /> 
											<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>
											<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
										</fieldset>
										–
										<fieldset  class="mb-0" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
											<input type="time" formControlName="end_time" />
											<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>
											<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
										</fieldset>

										<span *ngIf="getSlots((day.day).toLowerCase()).length > 1 && i > 0" role="button" (click)="removeSlot((day.day).toLowerCase(), i)">
											<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
											</svg>
										</span>

										<!-- ADD BUTTON -->
										<span *ngIf="i == 0" role="button" (click)="addSlot((day.day).toLowerCase())">
											<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
											</svg>
										</span>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>